// export function truncateToDecimals(num: number, decimals = 2) {
//     const factor = Math.pow(10, decimals);
//     return Math.floor(num * factor) / factor;
//   }

import { floor } from "lodash";

export function truncateToDecimals(num: number, decimals = 2) {
  const value = floor(num, decimals);
  return value;
}